var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Inventario por seriales","sub-title":"Ingreso de seriales"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('inventory-products-card',{attrs:{"stowage-id":_vm.stowageId}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }